import { ElasticSearchHelper } from '../../../utils/elastic-search-helper';
import { DEFAULT_ES_QUERY_FILTER } from '../../../constants/elastic-search';
import { FilterOperation } from '../../../interfaces/attribute-filters';
import { executionListTableMetadata } from '../../domain-tracker/table-metadata';
import { AppRoutes } from '../../common/router-common';
import { getStartDateAndEndDate } from '../../../utils/table-helper';

/**
 * Builds the execution list URL with an ES query filter for the given workflowIds.
 * Includes a workflowStartDate range filter (last 365 days) so the execution list page
 * does not discard the workflowId filter.
 */
export const buildExecutionListUrl = (workflowIds: string): string => {
  const idList = workflowIds.split(',').map(id => id.trim());

  const filterAttribute = {
    attributeName: { value: 'workflowId', label: 'Workflow Id' },
    condition: FilterOperation.EQUALS,
    value: workflowIds,
    columnDefinition: executionListTableMetadata['workflowId'],
    tableType: null
  };

  const timeFilterAttribute = {
    attributeName: { value: 'workflowStartDate', label: 'workflowStartDate' },
    condition: FilterOperation.BETWEEN,
    value: getStartDateAndEndDate(365),
    columnDefinition: executionListTableMetadata['workflowStartDate'],
    tableType: null
  };

  const sortingOptions = {
    isDescending: true,
    sortingColumn: { sortingField: 'workflowEndDate' }
  };

  const esQuery = JSON.stringify(ElasticSearchHelper.convertAttributeFilterTokensToESQueryV3({
    ...DEFAULT_ES_QUERY_FILTER,
    size: idList.length,
    attributeFilterItems: [filterAttribute, timeFilterAttribute],
    sortingOptions
  }));

  return `${AppRoutes.executionList}?esQuery=${encodeURIComponent(esQuery)}`;
};
